/* loaded by smart-asset */
export default require("./assets/error.mp3")